"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_controller_element_1 = require("./designer-elements/form-controller.element");
var form_card_element_1 = require("./designer-elements/form-card.element");
var form_header_element_1 = require("./designer-elements/form-header.element");
var form_tab_element_1 = require("./designer-elements/form-tab.element");
var form_nested_card_element_1 = require("./designer-elements/form-nested-card.element");
var form_subwaymap_element_1 = require("./designer-elements/form-subwaymap.element");
var FormElementFactory = /** @class */ (function () {
    function FormElementFactory() {
    }
    FormElementFactory.prototype.create = function (domInfo) {
        if (this.elemIsController(domInfo)) {
            return new form_controller_element_1.FormControllerElement(domInfo);
        }
        else if (this.elemIsCard(domInfo)) {
            return new form_card_element_1.FormCardElement(domInfo);
        }
        else if (this.elemIsHeader(domInfo)) {
            return new form_header_element_1.FormHeaderElement(domInfo);
        }
        else if (this.elemIsTab(domInfo)) {
            return new form_tab_element_1.FormTabElement(domInfo);
        }
        else if (this.elemIsNestedCard(domInfo)) {
            return new form_nested_card_element_1.FormNestedCardElement(domInfo);
        }
        else if (this.elemIsSubwayMap(domInfo)) {
            return new form_subwaymap_element_1.FormSubwayMapElement(domInfo);
        }
    };
    FormElementFactory.prototype.elemIsHeader = function (domInfo) {
        return domInfo.bagNameEquals(FormElementFactory.HEADER_BAG);
    };
    FormElementFactory.prototype.elemIsSubwayMap = function (domInfo) {
        return domInfo.bagNameEquals(FormElementFactory.SUBWAYMAP_BAG);
    };
    FormElementFactory.prototype.elemIsController = function (domInfo) {
        return domInfo.bagNameEquals(FormElementFactory.FIELDS_BAG) &&
            !domInfo.elemIdEquals(FormElementFactory.NESTED_CARDS_ID)
            && domInfo.getElemAttribute('is_nested_card') !== '1';
    };
    FormElementFactory.prototype.elemIsTab = function (domInfo) {
        return domInfo.bagNameEquals(FormElementFactory.TABS_BAG);
    };
    FormElementFactory.prototype.elemIsCard = function (domInfo) {
        return domInfo.bagNameEquals(FormElementFactory.CARDS_BAG);
    };
    FormElementFactory.prototype.elemIsNestedCard = function (domInfo) {
        return domInfo.bagNameEquals(FormElementFactory.FIELDS_BAG) &&
            (domInfo.elemIdEquals(FormElementFactory.NESTED_CARDS_ID)
                || domInfo.getElemAttribute('is_nested_card') === '1');
    };
    FormElementFactory.HEADER_BAG = 'headers-type-bag';
    FormElementFactory.FIELDS_BAG = 'fields-bag';
    FormElementFactory.TABS_BAG = 'tabs-type-bag';
    FormElementFactory.CARDS_BAG = 'card-type-bag';
    FormElementFactory.NESTED_CARDS_ID = 'nested_card_type';
    FormElementFactory.SUBWAYMAP_BAG = 'subwaymap-type-bag';
    return FormElementFactory;
}());
exports.FormElementFactory = FormElementFactory;
//# sourceMappingURL=form-element.factory.js.map